import React from 'react';
//import {connect} from 'react-redux';
import { Tile, Button, OverflowMenu, OverflowMenuItem } from '@carbon/react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import styles from './StreamDisplay.module.scss';

import { PreviewSlideshow } from '../Elements';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { hideForm } from '@/redux/new_services/forms';

const StreamDisplay = ({
  stream,
  onSelectStream = () => {},
  orientation,
  nowebgl,
}) => {
  let inner = null;

  const history = useNavigate();
  const dispatch = useDispatch();

  if (!stream || stream.model.ID === 0) {
    inner = (
      <div className={cx(styles.displayText)}>
        Kein Stream vorhanden
        <br />
        <Button kind="primary" size="field" onClick={onSelectStream}>
          Stream auswählen
        </Button>
      </div>
    );
  } else {
    inner = (
      <Tile className={cx(styles.displayTile)}>
        <div onClick={onSelectStream}>
          <PreviewSlideshow
            elements={stream.items}
            orientation={orientation || 0}
            nowebgl={nowebgl}
            size="big"
          />
        </div>

        <div className={cx(styles.footer)}>
          <div className={cx(styles.footerHead)}>{stream.name}</div>
          <OverflowMenu flipped aria-label="">
            <OverflowMenuItem
              itemText="Stream bearbeiten"
              onClick={() => {
                dispatch(hideForm());
                history(`/stream/${stream.model.ID}`);
              }}
            />
            <OverflowMenuItem
              itemText="neuen Stream auswählen"
              onClick={onSelectStream}
            />
          </OverflowMenu>
        </div>
      </Tile>
    );
  }

  return <div className={cx(styles.display)}>{inner}</div>;
};

StreamDisplay.propTypes = {
  stream: PropTypes.object.isRequired,
  onSelectStream: PropTypes.func.isRequired,
  onNewStream: PropTypes.func,
};

export default StreamDisplay;
